import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import OperationalBookingsTable from './OperationalBookingsTable';
import query from './getStalledBookings.graphql';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Stalled / abandoned bookings',
    component: (
      <AdminLayout>
        <OperationalBookingsTable
          query={query}
          dataKey="getStalledBookings"
          heading="Stalled / abandoned bookings — started, never completed"
          emptyMsg="No stalled bookings — nothing has been left hanging."
        />
      </AdminLayout>
    ),
  };
}

export default action;
